import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_394: DocMigration = {
  maxSchemaVersion: "0.0.394",
  description: "View Tempalate Style Data Structure Update",
  apply(json: any) {
    const { viewTemplates } = json;

    for (const templateId in viewTemplates) {
      const template = viewTemplates[templateId];

      for (const styleOverrideId in template.styleOverrides ?? {}) {
        const styleOverride = template.styleOverrides[styleOverrideId];

        template.styleOverrides[styleOverrideId] = {
          [sheetGeometryStyleMap[styleOverrideId]]: styleOverride,
        };
      }
    }

    return json;
  },
};

export const sheetGeometryStyleMap = {
  UNDEFINED: "line",
  FOOTING_EDGES: "line",
  SLAB: "line",
  SLAB_ABOVE: "line",
  SLAB_BELOW: "line",
  SLAB_PATIO: "line",
  SLAB_TAG: "text",
  BRICKLEDGE: "line",
  FOUNDATION_CURB: "line",
  STAIR: "line",
  STAIR_CROSS_SECTION: "line",
  STEM_WALL_UNIONED_EDGES: "line",
  STEM_WALL: "line",
  STEM_WALL_ABOVE: "line",
  STEM_WALL_ABOVE_GAPS: "line",
  STEM_WALL_BELOW: "line",
  PIER_EDGES_ONLY: "line",
  PIER_ALL: "line",
  FOUNDATION_LINEWORK: "line",
  FOUNDATION_DASHED_LINEWORK: "line",
  FOUNDATION_SOLID_LINEWORK: "line",
  ANNOTATION: "text",
  ANNOT_DETAIL: "line",
  ANNOT_LINEWORK: "line",
  ANNOT_NOTE: "text",
  ANNOT_DIM: "line",
  ANNOT_DIM_GROUP: "line",
  ANNOT_DIM_LABEL: "text",
  ANNOT_DIM_LINE: "line",
  ANNOT_DIM_LINEWORK: "line",
  ANNOT_DIM_TICK: "line",
  ANNOT_DIM_WITNESS: "line",
  TOP_OF_PLATE_ANNOTATION: "text",
  DORMER_WINDOW_VERTICAL_DIMENSIONS: "line",
  DORMER_WINDOW_TAGS: "text",
  ROOF_GABLE_WINDOW_VERTICAL_DIMENSIONS: "line",
  ROOF_GABLE_WINDOW_TAGS: "text",
  ROOF_DIM_ANNOTATION: "text",
  ROOF_SLOPE_SYMBOL: "line",
  WINDOW_HEADER_ANNOTATION: "text",
  ELEVATION_MARKERS: "line",
  MATERIAL_TAGS: "text",
  GRADE_LINE: "line",
  ELECTRICAL_CONTROLLERS: "line",
  ELECTRICAL_LINKS: "line",
  ELECTRICAL_LOADS: "line",
  PROPS: "line",
  PROP_TAG: "text",
  COLUMN: "line",
  DIM_LABEL: "text",
  DIM_LINE: "line",
  DIM_LINEWORK: "line",
  DIM_TICK: "line",
  DIM_WITNESS: "line",
  DIM_GROUP: "line",
  FOUNDATION_DIMENSIONS: "line",
  FOUNDATION_DIM_LABEL: "text",
  FOUNDATION_DIM_LINE: "line",
  FOUNDATION_DIM_LINEWORK: "line",
  FOUNDATION_DIM_TICK: "line",
  FOUNDATION_DIM_WITNESS: "line",
  FOUNDATION_DIM_GROUP: "line",
  WALL_INTERIOR_DIMENSIONS: "line",
  WALL_INTERIOR_DIM_LABEL: "text",
  WALL_INTERIOR_DIM_LINE: "line",
  WALL_INTERIOR_DIM_LINEWORK: "line",
  WALL_INTERIOR_DIM_TICK: "line",
  WALL_INTERIOR_DIM_WITNESS: "line",
  WALL_INTERIOR_DIM_GROUP: "line",
  WALL_EXTERIOR_DIMENSIONS: "line",
  WALL_EXTERIOR_DIM_LABEL: "text",
  WALL_EXTERIOR_DIM_LINE: "line",
  WALL_EXTERIOR_DIM_LINEWORK: "line",
  WALL_EXTERIOR_DIM_TICK: "line",
  WALL_EXTERIOR_DIM_WITNESS: "line",
  WALL_EXTERIOR_DIM_GROUP: "line",
  CONDITION_TAG: "text",
  CEILING: "line",
  RAILING: "line",
  RAILING_STAIR_ONLY: "line",
  RAILING_POST: "line",
  RAILING_POST_STAIR_ONLY: "line",
  PORCH_COLUMNS: "line",
  PORCH_BEAMS: "line",
  PORCH: "line",
  DECK: "line",
  PERIMS_WALL: "line",
  PERIMS_FLOORPLATE: "line",
  FLOOR_AREAS: "line",
  WALLS: "line",
  WALL_BOUNDARIES: "line",
  WALL_CORE: "line",
  WALL_SUBSTRATE: "line",
  WALL_EXTERIOR_FINISH: "line",
  CHASE_ROOMS: "line",
  CASEWORK: "line",
  CASEWORK_SOLID_DASH: "line",
  CASEWORK_POCHE: "line",
  DOORS: "line",
  DOOR_CASING_CUT: "line",
  WINDOWS: "line",
  WINDOW_CASING_CUT: "line",
  WAINSCOTING: "line",
  ROOM_LABELS: "text",
  WINDOW_TAGS: "text",
  DOOR_TAGS: "text",
  CASEWORK_TAG: "text",
  OPENING_TAGS: "text",
  INTERIOR_LABELS: "text",
  ROOF: "line",
  FLOOR_FINISH: "line",
  FLOOR_FRAMING: "line",
  FLOOR_FRAMING_LABEL: "text",
  ROOF_PERIMS: "line",
  ROOF_PERIMS_WITH_LEVEL_PERIMS: "line",
  ROOF_RIDGE_VENT_ANNOS: "text",
  ROOF_SLOPE_ANNOS: "text",
  ROOF_SKYLIGHT_ANNOS: "text",
  ROOF_OVERHANG_ANNOS: "text",
  ROOF_DORMER_ANNOS: "text",
  ALL_LVL_ANNOT_DIM: "line",
  ALL_LVL_ANNOT_DIM_GROUP: "line",
  ALL_LVL_ANNOT_DIM_LABEL: "text",
  ALL_LVL_ANNOT_DIM_LINE: "line",
  ALL_LVL_ANNOT_DIM_LINEWORK: "line",
  ALL_LVL_ANNOT_DIM_TICK: "line",
  ALL_LVL_ANNOT_DIM_WITNESS: "line",
  ALL_LVL_ANNOT_LINEWORK: "line",
  ALL_LVL_ANNOT_NOTE: "text",
  ALL_LVL_ANNOT_DETAIL: "line",
  FOUNDATION_FOOTING: "line",
  FOUNDATION_PIER: "line",
  TRIM: "line",
  WALL_FRAMING: "line",
  SUB_FLOORING: "line",
};

export default migration_0_0_394;
